import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { LaunchDialogService } from '../../../../core/modal';
import { ArticleImageModule, ArticleInfoModule, CheckboxModule, SpinnerModule } from '../../../../shared';
import { ModalModule } from '../../../../shared/components/modal';
import { ActionButtonModule } from '../../action-button';
import { excludeArticlesModalLayoutConfig } from './exclude-articles-modal-layout.config';
import { ExcludeArticlesModalComponent } from './exclude-articles-modal.component';

@NgModule({
  declarations: [ExcludeArticlesModalComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    SpinnerModule,
    ModalModule,
    CheckboxModule,
    ArticleInfoModule,
    ArticleImageModule,
    KeyboardFocusModule,
    ActionButtonModule,
  ],
  exports: [ExcludeArticlesModalComponent],
})
export class ExcludeArticlesModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(excludeArticlesModalLayoutConfig);
  }
}
